export default __webpack_public_path__ + "static/media/MMP Face Logo 2.78099ec6.svg";